import { IChuanDauRaChungChiSysRequest } from "../../model/request/chuong-trinh-dao-tao/IChuanDauRaChungChiSysRequest";
import { apiClient } from "../apiClient";

const CHUAN_DAU_RA_CHUNG_CHI_ENDPOINT = "chuan-dau-ra-chung-chi";
export const chuanDauRaChungChiApi = {
    SelectAll: () => apiClient.get(`${CHUAN_DAU_RA_CHUNG_CHI_ENDPOINT}`),
    Sys: (request: IChuanDauRaChungChiSysRequest) => apiClient.post(`${CHUAN_DAU_RA_CHUNG_CHI_ENDPOINT}/sys`, request),
}